import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const TaskErrorPopup = (props) => {
  const companyId = window.localStorage.getItem("companyId");
  const [playColor, setPlayColor] = useState("");
  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677733") {
      setPlayColor("#C6BE00");
    } else if (companyId === "28830f30-b321-4662-a576-f23451677744") {
      setPlayColor("#08A59E");
    } else {
      setPlayColor("#D8BD90");
    }
  }, []);

  const [fetchAddTask, setFetchAddTask] = useState({});
  const t = (key) => fetchAddTask?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Add-Task").then((res) => {
      setFetchAddTask(res);
    });
  }, []);

  return (
    <Modal
      show={props.showError}
      onHide={props.onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{
        zIndex: "9999",
        textAlign: "center",
        background: "#F2F2F2 0% 0% no-repeat padding-box",
        opacity: 0.95,
      }}
      className="error-modal"
      id="task-error-modal-id"
    >
      <div
        className="task-error-modal"
        style={{ fontSize: "var(--responsive-font-16)" }}
      >
        {props.cancel ? (
          <>
            <div className="information-addtask pop-up-text-add">
              {/* The information not be saved. */}
              {t("The information not be saved.")}
              {/* <span style={{ color: "#FF0000B3" }}> </span> */}
            </div>
            <div className="information-addtask">
              {/* Do you want to proceed? */}
              {t("Do you want to proceed?")}
            </div>
          </>
        ) : (
          <>
            {props.attachMessage ? (
              <div style={{ padding: "2rem" }}>
                <p
                  style={{
                    fontSize: "var(--responsive-font-18)",
                    color: "#444141",
                    margin: "0",
                  }}
                >
                  {props.attachMessage}
                </p>
              </div>
            ) : (
              <div>
                <p className="ascpls pop-up-text-add">
                  {/* Please fill in the information required to add this Task: */}
                  {t("Please fill in the information required to add this")}
                </p>

                {/* Type a Title */}
                {!props.title && (
                  <p className="ascpls m-0">{t("Type a Title")}</p>
                )}

                {/* Due Date */}
                {/* {!props.dueDate &&
                  <p className="ascpls m-0">{fetchAddTask[54]?.translation}</p>
                } */}
              </div>
            )}
          </>
        )}
        {props.cancel ? (
          <div style={{ marginTop: "5rem" }}>
            <button
              className="task-error-cancel-add"
              style={{ marginRight: "2rem", backgroundColor: "transparent" }}
              onClick={() => {
                if (props?.attachMessage) {
                  props.setAttachMessage("");
                  props.setImgUrl("");
                }
                props.setShowError && props.setShowError(false);
                props.onConfirmaion && props.onConfirmaion(false);
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              className="task-error-cancel-add"
              style={{
                color: "#FFFFFF",
                backgroundColor: `#F76767`,
                border: "none",
                // backgroundColor:"transparent"
              }}
              onClick={() => {
                props.setShowError && props.setShowError(false);
                props.setShowModal && props.setShowModal(false);
                props.onConfirmaion && props.onConfirmaion(true);
                props.setModalFunction("");
              }}
            >
              {/* YES */}
              {t("YES")}
            </button>
          </div>
        ) : (
          <div style={{ marginTop: "2rem" }}>
            <button
              className="task-error-cancel-add"
              style={{ marginRight: "2rem", backgroundColor: "transparent" }}
              onClick={() => {
                if (props?.attachMessage) {
                  props.setAttachMessage("");
                  props.setImgUrl("");
                }
                props.setShowError(false);
              }}
            >
              {/* Cancel */}
              {t("Cancel")}
            </button>
            <button
              className="task-error-cancel-add"
              style={{
                color: "#FFFFFF",
                // backgroundColor: `${playColor}`,
                backgroundColor: `#F76767`,
                border: "none",
              }}
              onClick={() => {
                props.setShowError(false);
              }}
            >
              {/* Ok */}
              {t("Ok")}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TaskErrorPopup;
